import React, { useState } from "react";
import {
  Box,
  Paper,
  Typography,
  TextField,
  Button,
  CircularProgress,
  Snackbar,
  Alert,
} from "@mui/material";
import { Login } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import api from "../../api";

export default function PreAdmissionLogin() {
  const [form, setForm] = useState({ application_no: "", dob: "" });
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState(null);
  const navigate = useNavigate();

  // ✅ Handle Login
  const handleLogin = async () => {
    if (!form.application_no || !form.dob) {
      setMsg({ type: "error", text: "Please enter Application No and DOB" });
      return;
    }

    setLoading(true);
    try {
      const res = await api.post("/application/login", form);
      if (res.data.status) {
        // ✅ Save applicant data to localStorage
        localStorage.setItem("preAdmissionData", JSON.stringify(res.data.data));

        // ✅ Redirect to dashboard
        navigate("/pre-admission/dashboard");
      } else {
        setMsg({ type: "error", text: res.data.message });
      }
    } catch (err) {
      console.error(err);
      setMsg({ type: "error", text: "Network error. Try again." });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        p: 3,
        maxWidth: 500,
        mx: "auto",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "80vh",
      }}
    >
      <Paper
        sx={{
          p: 4,
          textAlign: "center",
          borderRadius: 3,
          boxShadow: 4,
          width: "100%",
        }}
      >
        <Typography variant="h5" fontWeight={600} mb={2}>
          🎓 Pre-Admission Student Login
        </Typography>

        <TextField
          label="Application No"
          fullWidth
          margin="normal"
          value={form.application_no}
          onChange={(e) =>
            setForm({ ...form, application_no: e.target.value })
          }
        />

        <TextField
          label="Date of Birth"
          type="date"
          fullWidth
          margin="normal"
          InputLabelProps={{ shrink: true }}
          value={form.dob}
          onChange={(e) => setForm({ ...form, dob: e.target.value })}
        />

        <Button
          variant="contained"
          startIcon={<Login />}
          onClick={handleLogin}
          disabled={loading}
          sx={{ mt: 2 }}
          fullWidth
        >
          {loading ? <CircularProgress size={24} /> : "Login"}
        </Button>
      </Paper>

      {/* Snackbar */}
      <Snackbar
        open={!!msg}
        autoHideDuration={3000}
        onClose={() => setMsg(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        {msg && (
          <Alert severity={msg.type} sx={{ width: "100%" }}>
            {msg.text}
          </Alert>
        )}
      </Snackbar>
    </Box>
  );
}
